@use 'ui/styles/core-tokens' as core;

.text {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  max-width: 60%;

  &Value {
    margin-left: 5px;
    @include core.text-truncate;
  }

  &Btn {
    margin-left: auto;
  }
}
